export default __webpack_public_path__ + "media/6b77d0489f4e32c6e57cfe464048e593a7bfb1df4fbbc1b72aa8de831b7cd6f4.svg";